import { useCallback } from 'react'
import { useSetAtom } from 'jotai'

import { removeSelectedMarkerFromMapIfExists } from '@app/components/Molecules/MapView/GenericMapView/GenericMapView.utilities'
import {
  selectedFeatureAtom,
  selectedLayerAtom,
  selectedMarkerAtom,
} from '@app/risk-migration/atoms/riskMap.atoms'

export function useDeselectRiskFeature() {
  const setSelectedFeature = useSetAtom(selectedFeatureAtom)
  const setSelectedLayer = useSetAtom(selectedLayerAtom)
  const setSelectedMarker = useSetAtom(selectedMarkerAtom)

  return useCallback(() => {
    removeSelectedMarkerFromMapIfExists()

    setSelectedFeature(null)
    setSelectedLayer(null)
    setSelectedMarker(null)
  }, [setSelectedFeature, setSelectedLayer, setSelectedMarker])
}
